/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedShippingInfo_shipment = {
    readonly shippingAddress: {
        readonly displayCityStateCountry: string | null;
    } | null;
    readonly " $refType": "PdpSharedShippingInfo_shipment";
};
export type PdpSharedShippingInfo_shipment$data = PdpSharedShippingInfo_shipment;
export type PdpSharedShippingInfo_shipment$key = {
    readonly " $data"?: PdpSharedShippingInfo_shipment$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedShippingInfo_shipment">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedShippingInfo_shipment",
  "type": "Shipment",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "shippingAddress",
      "storageKey": null,
      "args": null,
      "concreteType": "Address",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "displayCityStateCountry",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = '63a4966ec5582ed4c6b378bf5597921b';
export default node;
